module.exports = __webpack_public_path__ + "static/media/spec_chart.01ac0fce.png";